export enum InputComponentTypesEnum {
  Text = 'text',
  Password = 'password',
}
